// extracted by mini-css-extract-plugin
export default {"scroll":"OrderVariantsEditModal_scroll__pMPX4","button":"OrderVariantsEditModal_button__wHiMw","empty":"OrderVariantsEditModal_empty__J8iKX"};